export default function AboutSection() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-12 md:gap-16 items-center">
          <div className="flex-1 w-full">
            <span className="text-[11px] text-foreground-500 uppercase tracking-widest font-semibold">About Us</span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-3 leading-tight">
              Your Trusted Source for the Best Sugargoo Spreadsheet
            </h2>
            <p className="mt-6 text-[15px] text-foreground-700 leading-relaxed max-w-lg">
              We are a dedicated team of spreadsheet researchers and community contributors who curate the most comprehensive Sugargoo Spreadsheet directory on the web. Our mission is to help shoppers like you find quality products quickly without the hassle of manual searching.
            </p>
            <p className="mt-4 text-[15px] text-foreground-700 leading-relaxed max-w-lg">
              Every link in our directory is verified for accuracy and organized by category. We update our listings daily to ensure you always have access to the freshest finds. Whether you are hunting for sneakers, streetwear, accessories, or budget-friendly gems, our Sugargoo Spreadsheet has you covered.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-600 text-white text-[14px] font-bold rounded-full hover:bg-primary-700 transition-all whitespace-nowrap cursor-pointer"
            >
              Browse Full Spreadsheet <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="flex-1 w-full flex gap-4">
            <div className="flex-1">
              <div className="w-full h-72 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Diverse%20creative%20team%20collaborating%20around%20large%20reclaimed%20wood%20table%20with%20multiple%20laptops%20displaying%20colorful%20spreadsheet%20interfaces%20and%20product%20grids%20on%20screens%2C%20modern%20bright%20co-working%20loft%20space%20with%20hanging%20Edison%20bulbs%20and%20large%20industrial%20windows%2C%20sticky%20notes%20on%20glass%20whiteboard%20wall%2C%20energetic%20startup%20culture%20atmosphere%20with%20coffee%20mugs%20and%20notebooks%20scattered%20naturally&width=500&height=700&seq=about-v4-left&orientation=portrait"
                  alt="Sugargoo Spreadsheet research workspace"
                  title="Sugargoo Spreadsheet Curation Team"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="flex-1 mt-8">
              <div className="w-full h-80 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Beautifully%20curated%20fashion%20and%20accessories%20collection%20including%20leather%20bags%20silk%20scarves%20brass%20jewelry%20and%20designer%20sunglasses%20artfully%20arranged%20on%20rustic%20reclaimed%20oak%20tabletop%2C%20warm%20atmospheric%20candlelit%20evening%20setting%20with%20string%20fairy%20lights%20twinkling%20softly%20in%20background%2C%20boutique%20artisan%20market%20stall%20aesthetic%2C%20rich%20varied%20textures%20of%20leather%20silk%20metal%20and%20woven%20fabrics%20in%20earthy%20jewel%20tones&width=600&height=800&seq=about-v4-right&orientation=portrait"
                  alt="Curated Sugargoo Spreadsheet products"
                  title="Sugargoo Spreadsheet Product Collection"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}